@if (icon()) {
  <mat-icon [svgIcon]="icon()"></mat-icon>
} @else {
  <mat-icon class="material-symbols-outlined">question_mark</mat-icon>
}
